<template>
	<div class="page-user-edit">
		<div class="pg-breadcrumb">
			<div class="breadcrumb-item em">管理員管理</div>
			<div class="breadcrumb-item">新增 管理員資料</div>
		</div>

		<div class="pg-block">
			<Spin fix class="pg-sub-loading" v-if="isSubmiting">
				<Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
				<div class="loading-text">Loading</div>
			</Spin>

			<div class="pg-form-wrap">
				<Row>
					<Col span="24">
						<Form :label-width="400">
							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>類型</span>
										</div>
										<RadioGroup v-model="form.type">
											<Radio :label="1" :checked="form.type==1">管理員</Radio>
											<Radio :label="2" :checked="form.type==2">門店人員</Radio>
										</RadioGroup>
									</FormItem>
								</Col>
							</Row>

							<Row :gutter="15">
								<Col span="14">
									<FormItem v-if="form.type == 2">
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>關聯門店</span>
										</div>
										<!-- <Input v-model="form.store_id"/> -->
										<Select placeholder="選擇關聯門店" v-model="form.store_id" filterable>
											<Option :value="item.ReceivingID" v-for="(item, index) in editList"
											        :key="item.ReceivingID">({{ item.cainiao_match }}) {{ item.ReceivingName }}
											</Option>
										</Select>
									</FormItem>
								</Col>
							</Row>

							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>帳號</span>
										</div>
										<Input v-model="form.username"/>
									</FormItem>
								</Col>
							</Row>

							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>密碼</span>
										</div>
										<Input type="password" password v-model="form.password"/>
									</FormItem>
								</Col>
							</Row>

							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>姓名</span>
										</div>
										<Input v-model="form.realname"/>
									</FormItem>
								</Col>
							</Row>

							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>電話號碼</span>
										</div>
										<Input v-model="form.phone"/>
									</FormItem>
								</Col>
							</Row>
							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>郵箱</span>
										</div>
										<Input type="email" v-model="form.email"/>
									</FormItem>
								</Col>
							</Row>
							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>性別</span>
										</div>
										<RadioGroup v-model="form.sex">
											<Radio :label="0" :checked="form.sex==1">男</Radio>
											<Radio :label="1" :checked="form.sex==2">女</Radio>
										</RadioGroup>
									</FormItem>
								</Col>
							</Row>

							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>歸屬地</span>
										</div>
										<RadioGroup v-model="form.retreat">
											<Radio :label="1" :checked="form.retreat==1">澳門</Radio>
											<Radio :label="2" :checked="form.retreat==2">内地</Radio>
										</RadioGroup>
									</FormItem>
								</Col>
							</Row>

							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<span>頭像</span>
										</div>
										<div class="form-upload-img">
											<div class="img-preview" v-if="uploadFile.base64">
												<img :src="uploadFile.base64" alt="">
											</div>
											<Upload :before-upload="handleBeforeUpload"
											        accept="image/png, image/jpg, image/jpeg"
											        action="">
												<div class="upload-btn">選擇圖片</div>
											</Upload>
											<div class="upload-tip">尺寸：320PX * 320PX，格式：PNG、JPG、JPEG</div>
										</div>
									</FormItem>
								</Col>
							</Row>

							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>用戶職能級別</span>
										</div>
										<Select placeholder="請選擇職能級別" v-model="form.user_role">
											<Option value="1">管理員</Option>
											<Option value="3">派送員</Option>
											<Option value="5">客服人員</Option>
											<Option value="7">其他</Option>
										</Select>
									</FormItem>
								</Col>
							</Row>

							<Row :gutter="15">
								<Col span="14">
									<FormItem>
										<div slot="label" class="form-label">
											<em class="red">* </em>
											<span>同城主號關聯</span>
										</div>

										<Select placeholder="選擇主號關聯" v-model="form.parent_id">
											<Option :value="item.id" v-for="(item, index) in samecityList"
											        :key="item.id">{{ item.name }}
											</Option>
										</Select>

									</FormItem>
								</Col>
							</Row>

							<FormItem>
								<div class="pg-btn-wrap">
									<div class="pg-btn style1" @click="handleCheckForm">新增</div>
									<div class="pg-btn" @click="handleBack">返回</div>
								</div>
							</FormItem>
						</Form>
					</Col>
				</Row>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			uploadFile: {
				file: '',
				base64: ''
			},
			editList: [],
			samecityList: [],
			pageParam: {},
			pickRole: [],//角色
			detail: {},
			isSubmiting: false,
			form: {
				username: '',
				password: '',
				type: '',
				realname: '',
				avatar: '',
				phone: '',
				email: '',
				sex: '',
				store_id: '',
				parent_id: '',
				user_role: '',
				retreat: 1
			}
		};
	},
	mounted() {
		this.pageParam = this.$route.query;
		if (this.pageParam.id == undefined) {
			this.pageParam.id = 0;
		}
		// this.getDetail();
		this.getShopList();
		this.getSamcityList();
	},
	methods: {
		handleBack() {
			this.$router.go(-1);
		},
		//上传
		handleBeforeUpload(file) {
			this.uploadFile.file = file;
			this.hanldeImgToBase64();
			return false;
		},
		hanldeImgToBase64() {
			let file = this.uploadFile.file;
			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				let _base64 = reader.result;
				this.uploadFile.base64 = _base64;
			};
			this.handleUploadImg();
		},
		handleUploadImg() {
			this.isSubmiting = true;
			let formData = new FormData();
			formData.append('file', this.uploadFile.file);
			this.$Rq.requestAuth({
				url: this.$Api.uploadImg,
				method: 'post',
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data',
				}
			}).then((res) => {
				this.isSubmiting = false;
				if (res.code == 0) {
					this.form.avatar = res.data.app_url + res.data.url;
				} else {
					this.$Utils.showTipInfo(res.msg);
				}
			}).catch((err) => {
				this.isSubmiting = false;
			});
		},
		getShopList() {
			this.$Rq.requestAuth({
				url: this.$Api.pickAddress,
				method: 'get',
				data: {
					// company_id: 1,
					type: 1   //type 1門店， 2是智能櫃
				}
			}).then((res) => {
				if (res.code == 0) {
					this.editList = res.data.data;
				}
			});
		},
		getSamcityList() {
			this.$Rq.requestAuth({
				url: this.$Api.samecityUserList,
				method: 'get',
			}).then((res) => {
				if (res.code == 0) {
					this.samecityList = res.data.data;
				}
			});
		},
		// getDetail() {
		// if(this.pageParam.id != undefined) {
		// 	this.$Rq.requestAuth({
		// 	    url: this.$Api.adminDetail + '/' + this.pageParam.id,
		// 	    method: 'get'
		// 	}).then((res) => {
		// 	    if (res.code == 0) {
		// 	        let resData = res.data;
		// 	        this.form = {
		// 	            username: resData.username,
		// 				password: '',
		// 				realname: resData.realname,
		// 				avatar: resData.avatar,
		// 	            phone: resData.phone,
		// 				email: resData.email,
		// 				sex: resData.sex,
		// 				type: resData.type,
		// 				store_id: resData.store_id,
		// 				parent_id: resData.parent_id,
		// 				user_role: resData.user_role,
		// 	        };
		// 			this.uploadFile.base64 = resData.avatar
		// 	    }
		// 	});
		// }
		// },
		handleCheckForm() {
			let form = this.form;
			if (form.type === '') {
				this.$Utils.showTipInfo('請選擇類型');
				return;
			}
			if (form.username === '') {
				this.$Utils.showTipInfo('請輸入帳號');
				return;
			}
			if (form.password === '') {
				this.$Utils.showTipInfo('請輸入密碼');
				return;
			}
			if (form.realname === '') {
				this.$Utils.showTipInfo('請輸入姓名');
				return;
			}
			if (form.phone === '') {
				this.$Utils.showTipInfo('請輸入電話號碼');
				return;
			}
			if (form.email === '') {
				this.$Utils.showTipInfo('請輸入郵箱');
				return;
			}
			if (form.sex === '') {
				this.$Utils.showTipInfo('請選擇性別');
				return;
			}
			if ((form.store_id === 0 || form.store_id === '' || form.store_id === undefined || form.store_id === null) && form.type === 2) {
				this.$Utils.showTipInfo('請輸入關聯門店');
				return;
			}
			if (form.user_role === '') {
				this.$Utils.showTipInfo('請選擇職能級別');
				return;
			}
			if (form.parent_id === '') {
				this.$Utils.showTipInfo('請選擇同城主號關聯');
				return;
			}
			this.handleSubmit();
		},
		handleSubmit() {
			let form = this.form;
			this.isSubmiting = true;

			if (form.type == 1) {
				form.store_id = 0;
			}

			this.$Rq.requestAuth({
				url: this.$Api.adminUpdate + '/' + this.pageParam.id,
				method: 'post',
				data: {
					username: form.username,
					password: form.password,
					realname: form.realname,
					avatar: form.avatar,
					phone: form.phone,
					email: form.email,
					sex: form.sex,
					type: form.type,
					store_id: form.store_id,
					parent_id: form.parent_id == undefined ? 1 : form.parent_id,
					user_role: form.user_role,
					retreat: form.retreat,
				}
			}).then((res) => {
				this.isSubmiting = false;
				if (res.code == 0) {
					this.$Utils.showSuccess(res.msg);
					this.form = {
						username: '',
						password: '',
						type: '',
						realname: '',
						avatar: '',
						phone: '',
						email: '',
						sex: '',
						store_id: '',
						parent_id: '',
						user_role: '',
						retreat: 1,
					};
				} else {
					this.$Utils.showTipInfo(res.msg);
				}
			}).catch((err) => {
				this.isSubmiting = false;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
	/*::v-deep.ivu-input-wrapper {
		width: 200px !important;
	}
	::v-deep.upload-tip {
		min-width: 200px !important;
	}
	::v-deep.ivu-select {
		width: 200px !important;
	}*/
@import "AdminAdd.scss";
</style>
